export const header_ru = {
    main: "Главная",
    logIn: "Войти",
    logOut: "Выйти",
    exhibition: "Выставка",
    info: "Информация",
    participans: "Участие",
    blog: "Новости",
    account: 'Личный кабинет',
}